import { Component, Input } from '@angular/core';

@Component({
  selector: 'ap-dynamic-content-outlet-error',
  template: `
    <div>{{ errorMessage }}</div>
  `
})
export class DynamicContentOutletErrorComponent {
  @Input() errorMessage: string;
  constructor() { }
}
